@if (isThinkingState() || hasRegularThoughtOrCitation()) {
  <div class="ai-thinking-window">
    <div
      class="ai-thinking-window__header"
      [class.ai-thinking-window__header--clickable]="hasRegularThoughtOrCitation()"
      (click)="hasRegularThoughtOrCitation() && toggleCollapse()"
      [attr.aria-live]="isThinkingState() ? 'polite' : null"
    >
      <div class="ai-thinking-window__left">
        @if (!isThinkingState() && hasRegularThoughtOrCitation()) {
          <span class="ai-thinking-window__title">
            {{ 'INBOX.CITATIONS.THOUGHTS_SHOW' | translate }}
          </span>
        }
        @if (isThinkingState()) {
          <span class="ai-thinking-window__title ai-thinking-window__title--thinking">
            {{ 'INBOX.CITATIONS.THINKING_TITLE' | translate }}<span class="ai-thinking-window__dots"></span>
          </span>
        }
      </div>

      @if (!isThinkingState() && hasRegularThoughtOrCitation()) {
        <button
          type="button"
          class="ai-thinking-window__toggle"
          [attr.aria-label]="isCollapsed() ? 'Expand thoughts' : 'Collapse thoughts'"
        >
          <mat-icon class="ai-thinking-window__toggle-icon material-symbols-outlined">
            {{ isCollapsed() ? 'expand_more' : 'expand_less' }}
          </mat-icon>
        </button>
      }
    </div>

    <div
      #streamingBody
      class="ai-thinking-window__body"
      [class.ai-thinking-window__body--streaming]="isThinkingState() && regularThoughts().length"
      [class.ai-thinking-window__body--collapsed]="isCollapsed()"
      role="log"
    >
      @if (regularThoughts().length) {
        <ul class="ai-thinking-window__thoughts" [class.ai-thinking-window__thoughts--streaming]="isThinkingState()">
          @for (item of regularThoughts(); track item.sequenceNumber) {
            @if (item.type !== ThoughtType.REASONING) {
              <li class="ai-thinking-window__thought-function-content citation">
                <a (click)="openFunctionCallDetails(item.content)">
                  <mat-icon class="material-symbols-outlined file-icon">offline_bolt</mat-icon>
                  <p class="text-ellipsis md:text-clip">
                    @if (item.state === ThoughtState.RUNNING) {
                      <strong>Running: {{ item.functionName }}</strong>
                    } @else {
                      Completed: {{ item.functionName }}
                    }
                  </p>
                </a>
              </li>
            } @else {
              <li class="ai-thinking-window__thought-item">
                <div class="ai-thinking-window__thought-content citation" [innerHTML]="item.formattedContent"></div>
              </li>
            }
          }
        </ul>
      }

      @if (!hideCitations() && citationsUIModel() && citationsUIModel().length > 0) {
        <mat-divider></mat-divider>
        <div class="ai-thinking-window__citations">
          <div class="ai-thinking-window__citations-list">
            @for (citation of citationsUIModel(); track $index) {
              @if (citation?.fileUrl && citation && supportsFilePreview(citation)) {
                <a (click)="openWebsitePreview(citation)">
                  <glxy-badge [size]="'small'" [color]="'blue-solid'">
                    <mat-icon class="fa fa-lg">search</mat-icon> {{ citation.title }}
                  </glxy-badge>
                </a>
              } @else if (citation.type === CitationType.TYPE_FILE) {
                <a [href]="citation.link" target="_blank" rel="noreferrer noopener">
                  <glxy-badge [size]="'small'" [color]="'blue-solid'">
                    <mat-icon class="fa fa-lg">description</mat-icon> {{ citation.title }}
                  </glxy-badge>
                </a>
              } @else {
                <a [href]="citation.link" target="_blank" rel="noreferrer noopener">
                  <glxy-badge [size]="'small'" [color]="'blue-solid'">
                    <mat-icon class="fa fa-lg">edit_note</mat-icon> {{ citation.title }}
                  </glxy-badge>
                </a>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
}
